module.exports = __webpack_public_path__ + "img/handball.ec024020.svg";